/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */
import * as i0 from '@angular/core';
import * as i1 from '../expediente/expediente-view.component.ngfactory';
import * as i2 from '../../../../../src/app/components/expediente/expediente-view.component';
import * as i3 from '@angular/http';
import * as i4 from '../../../../../src/app/services/tasas.service';
import * as i5 from '../../../../../src/app/services/expediente.service';
import * as i6 from '../../../../../src/app/services/actuacion.service';
import * as i7 from '../../../../../src/app/services/common.service';
import * as i8 from '../../../../../src/app/services/websocket.service';
import * as i9 from '@angular/common';
import * as i10 from '../../../../../src/app/components/search/search-result.component';
import * as i11 from '../../../../../src/app/services/search.service';
import * as i12 from '@angular/router';
var styles_SearchResultComponent = [];
export var RenderType_SearchResultComponent = i0.ɵcrt({ encapsulation: 2,
    styles: styles_SearchResultComponent, data: {} });
function View_SearchResultComponent_1(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 8, 'div', [['class',
                'block-header']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n        '])), (_l()(), i0.ɵeld(0, null, null, 1, 'h2', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['', ''])), (_l()(),
            i0.ɵeld(0, null, null, 0, 'br', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n        '])), (_l()(), i0.ɵeld(0, null, null, 1, 'h6', [], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['Resultados para: "', '"'])), (_l()(), i0.ɵted(null, ['\n    ']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.filter.name;
        _ck(_v, 3, 0, currVal_0);
        var currVal_1 = _co.filter.query;
        _ck(_v, 7, 0, currVal_1);
    });
}
function View_SearchResultComponent_2(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 3, 'div', [['class',
                'block-header']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n        '])), (_l()(), i0.ɵeld(0, null, null, 0, 'i', [['class', 'fa fa-circle-o-notch fa-spin fa-3x fa-fw']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n    ']))], null, null);
}
function View_SearchResultComponent_6(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 1, 'expediente-view', [], null, null, null, i1.View_ExpedienteViewComponent_0, i1.RenderType_ExpedienteViewComponent)), i0.ɵdid(245760, null, 0, i2.ExpedienteViewComponent, [i3.Http, i4.TasasService, i5.ExpedienteService, i6.ActuacionService, i7.CommonService,
            i8.WebSocketService], { expId: [0, 'expId'], showToolbar: [1, 'showToolbar'], mostrarZocalo: [2,
                'mostrarZocalo'] }, null)], function (_ck, _v) {
        var currVal_0 = _v.parent.context.$implicit.entId;
        var currVal_1 = false;
        var currVal_2 = false;
        _ck(_v, 1, 0, currVal_0, currVal_1, currVal_2);
    }, null);
}
function View_SearchResultComponent_7(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 1, 'expediente-view', [], null, null, null, i1.View_ExpedienteViewComponent_0, i1.RenderType_ExpedienteViewComponent)), i0.ɵdid(245760, null, 0, i2.ExpedienteViewComponent, [i3.Http, i4.TasasService, i5.ExpedienteService, i6.ActuacionService, i7.CommonService,
            i8.WebSocketService], { expId: [0, 'expId'] }, null)], function (_ck, _v) {
        var currVal_0 = _v.parent.context.$implicit.expId;
        _ck(_v, 1, 0, currVal_0);
    }, null);
}
function View_SearchResultComponent_8(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 4, 'div', [], null, null, null, null, null)), (_l()(),
            i0.ɵted(null, ['\n			            '])), (_l()(), i0.ɵeld(0, null, null, 1, 'h4', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['Tipo desconocido o no implementado'])),
        (_l()(), i0.ɵted(null, ['\n		            ']))], null, null);
}
function View_SearchResultComponent_5(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵted(null, ['\n                '])), (_l()(),
            i0.ɵeld(0, null, null, 12, 'span', [], null, null, null, null, null)), i0.ɵdid(16384, null, 0, i9.NgSwitch, [], { ngSwitch: [0, 'ngSwitch'] }, null),
        (_l()(), i0.ɵted(null, ['\n                    '])), (_l()(), i0.ɵand(16777216, null, null, 1, null, View_SearchResultComponent_6)),
        i0.ɵdid(278528, null, 0, i9.NgSwitchCase, [i0.ViewContainerRef, i0.TemplateRef,
            i9.NgSwitch], { ngSwitchCase: [0, 'ngSwitchCase'] }, null), (_l()(), i0.ɵted(null, ['\n		            '])), (_l()(), i0.ɵand(16777216, null, null, 1, null, View_SearchResultComponent_7)), i0.ɵdid(278528, null, 0, i9.NgSwitchCase, [i0.ViewContainerRef, i0.TemplateRef, i9.NgSwitch], { ngSwitchCase: [0,
                'ngSwitchCase'] }, null), (_l()(), i0.ɵted(null, ['\n                    '])),
        (_l()(), i0.ɵted(null, ['\n		            '])), (_l()(), i0.ɵand(16777216, null, null, 1, null, View_SearchResultComponent_8)),
        i0.ɵdid(16384, null, 0, i9.NgSwitchDefault, [i0.ViewContainerRef, i0.TemplateRef,
            i9.NgSwitch], null, null), (_l()(), i0.ɵted(null, ['\n	            '])), (_l()(), i0.ɵted(null, ['\n		    ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.filter.id;
        _ck(_v, 2, 0, currVal_0);
        var currVal_1 = 1;
        _ck(_v, 5, 0, currVal_1);
        var currVal_2 = 0;
        _ck(_v, 8, 0, currVal_2);
    }, null);
}
function View_SearchResultComponent_10(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 10, 'button', [['class',
                'btn btn-novedad btn-verMas'], ['href', '']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.cargarMas() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), i0.ɵted(null, ['\n                            '])),
        (_l()(), i0.ɵeld(0, null, null, 7, 'ul', [['class', 'list-inline']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                                '])), (_l()(),
            i0.ɵeld(0, null, null, 4, 'li', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                                    '])), (_l()(), i0.ɵeld(0, null, null, 1, 'h4', [['class', 'totem verMas']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['Ver más ', ''])), (_l()(), i0.ɵted(null, ['\n                                '])),
        (_l()(), i0.ɵted(null, ['\n                            '])), (_l()(), i0.ɵted(null, ['\n                        ']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.filter.name;
        _ck(_v, 7, 0, currVal_0);
    });
}
function View_SearchResultComponent_9(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 10, 'div', [], null, null, null, null, null)), (_l()(),
            i0.ɵted(null, ['\n                '])), (_l()(), i0.ɵeld(0, null, null, 7, 'div', [['class', 'col-xs-12 col-sm-4 col-md-offset-4']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                    '])), (_l()(), i0.ɵeld(0, null, null, 4, 'div', [['class', 'btn-demo miniToverflow']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                        '])),
        (_l()(), i0.ɵand(16777216, null, null, 1, null, View_SearchResultComponent_10)),
        i0.ɵdid(16384, null, 0, i9.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0,
                'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n                    '])),
        (_l()(), i0.ɵted(null, ['\n                '])), (_l()(), i0.ɵted(null, ['\n            ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = (_co.showing < _co.results.total);
        _ck(_v, 7, 0, currVal_0);
    }, null);
}
function View_SearchResultComponent_4(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵted(null, ['\n            '])), (_l()(), i0.ɵand(16777216, null, null, 1, null, View_SearchResultComponent_5)), i0.ɵdid(802816, null, 0, i9.NgForOf, [i0.ViewContainerRef, i0.TemplateRef, i0.IterableDiffers], { ngForOf: [0, 'ngForOf'], ngForTrackBy: [1, 'ngForTrackBy'] }, null), (_l()(),
            i0.ɵted(null, ['\n            '])), (_l()(), i0.ɵand(16777216, null, null, 1, null, View_SearchResultComponent_9)), i0.ɵdid(16384, null, 0, i9.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0, 'ngIf'] }, null),
        (_l()(), i0.ɵted(null, ['\n        ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.dataShowing;
        var currVal_1 = _co.trackByFn;
        _ck(_v, 2, 0, currVal_0, currVal_1);
        var currVal_2 = (_co.showing < _co.results.total);
        _ck(_v, 5, 0, currVal_2);
    }, null);
}
function View_SearchResultComponent_11(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵted(null, ['\n            '])), (_l()(), i0.ɵeld(0, null, null, 1, 'h4', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['No se encontraron resultados'])),
        (_l()(), i0.ɵted(null, ['\n		']))], null, null);
}
function View_SearchResultComponent_3(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 7, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n        '])), (_l()(), i0.ɵand(16777216, null, null, 1, null, View_SearchResultComponent_4)), i0.ɵdid(16384, null, 0, i9.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0, 'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n        '])), (_l()(), i0.ɵand(16777216, null, null, 1, null, View_SearchResultComponent_11)),
        i0.ɵdid(16384, null, 0, i9.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0,
                'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n    ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = (_co.dataShowing.length > 0);
        _ck(_v, 3, 0, currVal_0);
        var currVal_1 = (_co.results.total == 0);
        _ck(_v, 6, 0, currVal_1);
    }, null);
}
export function View_SearchResultComponent_0(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 10, 'div', [['class',
                'container-fluid container-cards-pf container-pf-nav-pf-vertical container-pf-nav-pf-vertical-with-secondary col-xs-12 col-md-10 col-md-push-1 col-md-push-1']], null, null, null, null, null)), (_l()(),
            i0.ɵted(null, ['\n    '])), (_l()(), i0.ɵand(16777216, null, null, 1, null, View_SearchResultComponent_1)), i0.ɵdid(16384, null, 0, i9.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0, 'ngIf'] }, null),
        (_l()(), i0.ɵted(null, ['\n    '])), (_l()(), i0.ɵand(16777216, null, null, 1, null, View_SearchResultComponent_2)), i0.ɵdid(16384, null, 0, i9.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0, 'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n    '])), (_l()(), i0.ɵand(16777216, null, null, 1, null, View_SearchResultComponent_3)),
        i0.ɵdid(16384, null, 0, i9.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0,
                'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.filter;
        _ck(_v, 3, 0, currVal_0);
        var currVal_1 = !_co.filter;
        _ck(_v, 6, 0, currVal_1);
        var currVal_2 = _co.results;
        _ck(_v, 9, 0, currVal_2);
    }, null);
}
export function View_SearchResultComponent_Host_0(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 1, 'search-result', [], null, null, null, View_SearchResultComponent_0, RenderType_SearchResultComponent)), i0.ɵdid(114688, null, 0, i10.SearchResultComponent, [i11.SearchService, i12.Router, i12.ActivatedRoute], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
export var SearchResultComponentNgFactory = i0.ɵccf('search-result', i10.SearchResultComponent, View_SearchResultComponent_Host_0, {}, {}, []);
//# sourceMappingURL=search-result.component.ngfactory.js.map